import ContractorIcon from './component'

export default ContractorIcon
